import * as React from 'react';

import PrimaryButton from '../../../../../shared/buttons/PrimaryButton';

interface Props {
  onPress: () => void;
}

const CreateBackgroundButton: React.FunctionComponent<Props> = props => {
  const {onPress} = props;
  return (
    <PrimaryButton onPress={onPress}>背景をアップロードする</PrimaryButton>
  );
};

export default React.memo(CreateBackgroundButton);
